import { render, staticRenderFns } from "./AnalysesTactique.vue?vue&type=template&id=ff9c916a&"
import script from "./AnalysesTactique.vue?vue&type=script&lang=ts&"
export * from "./AnalysesTactique.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports